<div class="action-variable">
    <div *ngIf="getAvailableVariable(variable.key).options.multiple else singleselector"> 
            <!-- selector with search by now for labels only by key -->
        <div class="rules-action-variable-multiple-labels-searchable" 
            *ngIf="ACTION_LABELS_SEARCHABLE_KEYS.includes(variable.key) else multipleselector">
            <!-- access_request_labels searchable -->
            <settings-rules-rule-form-helper-search-main
                [term]="term"
                [found]="found"
                [variable]="getAvailableVariable(variable.key)"
                [result]="variable.value"
                (termChanges)="onSetTerm($event)"
                (removeFilter)="onRemove($event)"
                (selectedChanges)="onSelectActionMultiple($event)"
            ></settings-rules-rule-form-helper-search-main>
        </div>
        <!-- other multiple selectors -->
        <ng-template #multipleselector>
            <!-- multiple select as usually with checkboxes -->
            <div class="rules-action-variable-multiple">
                <settings-rules-rule-form-helper-select-multiple
                    [label]="getAvailableVariable(variable.key).description"
                    [options]="getAvailableVariable(variable.key).values"
                    [optionsSelected]="variable.value"
                    [key] = "variable.key"
                    (select)="onSelectActionMultiple($event)"
                ></settings-rules-rule-form-helper-select-multiple>
            </div>
        </ng-template>

    </div>
    <!-- default rule selector -->
    <ng-template #singleselector >
        <div class="rules-action-variable">
            <settings-rules-rule-form-helper-select
                [placeholder]="placeholder"
                [label]="getAvailableVariable(variable.key).description"
                [options]="getAvailableVariable(variable.key).values"
                [optionSelected]="variable.value"
                (actionSelect)="onSelectAction($event)"
            ></settings-rules-rule-form-helper-select>
        </div>
    </ng-template>
</div>